import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';

import { ButtonPrimary } from '../../../../common/components';

type TpiDataRequestFailureModalProps = {
  show: boolean;
  onHide: Function;
};

const defaultProps = {
  show: false,
};

export const Wrapper = styled.div``;

export const TpiDataRequestFailureModal = (props: TpiDataRequestFailureModalProps) => {
  const handleClose = (event: any) => {
    event.preventDefault();
    props.onHide();
  };

  return (
    <Modal animation={false} className={'custom-modal'} show={props.show} backdrop='static' centered>
      <Wrapper>
        <Modal.Title>
          <div className='text-center'>Broker/TPI data request failure</div>
        </Modal.Title>

        <Modal.Body>
          <div className='text-center'>
            <div className='pt-3'>
              <p>Unfortunately we can't process your request at this time.</p>
              <p>Please try again later.</p>
            </div>
          </div>
        </Modal.Body>

        <div className='d-flex justify-content-end'>
          <ButtonPrimary className='m-0' title='OK' onClick={handleClose} />
        </div>
      </Wrapper>
    </Modal>
  );
};

TpiDataRequestFailureModal.defaultProps = defaultProps;
